export const locale = {
  lang: 'ar',
  data: {
    MENU: {
      DASHBOARD: {
        Statistics: 'الإحصائيات',
        "MANAGE_STORE": "إدارة المتجر",
        "NOTIFICATIONS": "الإشعارات",
        "STORES": "المتاجر",
        "MERCHANTS": "التجار",
        "SUPPORT": "الدعم",
        "BUY_NOTIFICATIONS_CREDIT": "شراء رصيد الإشعارات",
        title: "المتاجر",
        description: "جميع المتاجر المدرجة في النظام...",
        show: "عرض",
        search: "بحث",
        name: "الاسم",
        descriptions: "الوصف",
        menu: "القائمة",
        logo: "الشعار",
        address: "العنوان",
        category: "الفئة",
        managedBy: "يدار بواسطة",
        actions: "الإجراءات",
        edit: "تعديل",
        delete: "حذف",
        "NOTIFICATION_PACKAGES": "حزم الإشعارات",
        "STATISTICS": "الإحصائيات",
        "ALL_STATISTICS_LISTED": "جميع الإحصائيات المدرجة في النظام...",
        "SHOW": "عرض",
        "SEARCH": "بحث",
        "SUPPLIER": "المورد",
        "ACTIONS": "الإجراءات",
        "ITEMS": "العناصر",
        "DETAILS": "التفاصيل",
  "ALL_MANAGE_STORE_LISTED": "جميع المتاجر المدرجة في النظام...",
  "ALL_NOTIFICATIONS_LISTED": "جميع الإشعارات المدرجة في النظام...",
   "ALL_MERCHANTS_LISTED": "جميع التجار المدرجين في النظام...",
   "NAME": "الاسم",
   "ENTER_NAME": "أدخل الاسم",
   "EMAIL": "البريد الإلكتروني",
   "ENTER_EMAIL": "أدخل البريد الإلكتروني",
   "MANAGED_STORE": "المتجر المُدار (الاسم والشعار) ",
   "ALL_SUPPORT_LISTED": "جميع الدعم المدرج في النظام...",
  "ALL_NOTIFICATION_PACKAGES_LISTED": "جميع حزم الإشعارات المدرجة في النظام...",
  "PRICE": "السعر",
  "DURATION": "المدة",
  "USAGE_LIMIT": "حد الاستخدام",
  "STORE_OFFERS": "عروض المتجر",
  "ADDRESS": "العنوان",
  "ADD_OFFER": "إضافة عرض",
  "TITLE": "العنوان",
  "PHOTO": "الصورة",
  "ORIGINAL_PRICE": "السعر الأصلي",
  "DISCOUNT": "الخصم",
  "REQUIRED_POINTS": "النقاط المطلوبة",
   "STORE_GALLERY": "معرض المتجر",
   "ADD_STORE": "إضافة متجر",
   "UPLOAD_LOGO": "رفع الشعار",
   "CATEGORY": "الفئة",
   "SELECT_STORE_CATEGORY": "اختر فئة المتجر...",
   "STORE_MANAGER": "مدير المتجر",
   "SELECT_STORE_MANAGER": "اختر مدير المتجر...",
   "DESCRIPTION": "الوصف",
   "MENU_URL": "رابط القائمة",
   "OPENING_TIME": "وقت الفتح",
   "CLOSING_TIME": "وقت الإغلاق",
   "SAVE": "حفظ",
   "Password": "كلمة السر",
   "PLACEHOLDER_NAME": "الاسم...",
   "PLACEHOLDER_Password": "كلمة السر...",
   "PLACEHOLDER_DESCRIPTION": "الوصف...",
   "PLACEHOLDER_MENU_URL": "رابط القائمة...",
   "PLACEHOLDER_ADDRESS": "العنوان...",
   "PLACEHOLDER_OPENING_TIME": "وقت الفتح...",
   "PLACEHOLDER_CLOSING_TIME": "وقت الإغلاق...",
    "PLACEHOLDER_EMAIL": "البريد الإلكتروني...",
  "ADD_MERCHANT": "إضافة تاجر",
  "SUPPORT_TICKETS": "تذاكر الدعم",
  "ALL_SUPPORT_TICKETS": "جميع تذاكر الدعم المدرجة في النظام...",
  "STATUS": "الحالة",
  "ALL_STORE_CATEGORIES": "جميع فئات المتاجر المدرجة في النظام...",
  "LAST_UPDATED": "آخر تحديث",
  "STORE_CATEGORIES": "فئات المتاجر",
  "ADD_STORE_CATEGORIES": "إضافة فئة ",
"ADD_NOTIFICATION_PACKAGE": "إضافة حزمة إشعارات",
  "UPLOAD_ICON": "رفع الأيقونة",

  "PLACEHOLDER_DURATION": "أدخل المدة...",
  "PLACEHOLDER_PRICE": "أدخل السعر...",
  "PLACEHOLDER_USAGE_LIMIT": "أدخل حد الاستخدام...",
  "ADD_PACKAGE": "إضافة الحزمة",
  "OPEN_SUPPORT_TICKET": "فتح تذكرة دعم",
  "SELECT_CATEGORY": "اختر فئة...",
  "PLACEHOLDER_TITLE": "أدخل العنوان...",
  "SEND_REQUEST": "إرسال الطلب",
    "BUY_NOTIFICATION_CREDIT": "شراء رصيد الإشعارات",
  "ALL_BUY_NOTIFICATION_CREDIT": "جميع عمليات شراء رصيد الإشعارات المدرجة في النظام...",
  "STORE_QR_CODE": "تخزين رمز الاستجابة السريعة",
  "TARGET_LINK": "رابط الهدف",
  "VALID_TARGET_LINK": "يرجى إدخال رابط هدف صالح.",
  "DOWNLOAD_QR": "تنزيل رمز الاستجابة السريعة",
  "GENERATE_UPDATE_QR": "إنشاء / تحديث رمز الاستجابة السريعة",
  "TARGET_LINK_PLACEHOLDER": "رابط الهدف ...",
  "AVAILABLE_PACKAGES": "الباقات المتاحة",
  "STORE_NOTIFICATIONS": "إشعارات المتجر",
  "USED": "مستخدم",
  "NOTIFICATIONS_PREMIUM": "إشعارات بريميوم",
  "NOTIFICATIONS_SENT": "75 من 100 إشعار تم إرساله",
  "END_DATE": "ينتهي في 21/05/2025",
  "ACTIVE": "نشط",
  "RENEW_SUBSCRIPTION": " شراء حزمة اشعارات جديدة",
  "SEND_NOTIFICATIONS": "إرسال الإشعارات",
  "SEARCH_USERS": "ابحث عن المستخدمين...",
      "SORT_BY": "فرز حسب",
      "OTHER_DETAILS": "تفاصيل أخرى...",
      "MEMBERSHIP_NAME": "اسم العضوية",
      "POINTS_AVAILABLE": "عدد النقاط المتوفرة",
      "QR_USE_COUNT": "عدد مرات استخدام الQR",
      "LAST_QR_USE": "آخر استخدام للQR",
      "FROM_DATE": "من التاريخ",
      "TO_DATE": "إلى التاريخ",
      "GET_DATA": "احصل على البيانات",
      "STORE_STATISTICS": "إحصائيات المتجر",
      "OLD_USERS": "المستخدمون القدامى",
      "NEW_USERS": "المستخدمون الجدد",
      "QR_SCANS_THIS_YEAR": "مسح رموز QR لهذا العام",
      "QR_SCANS_THIS_MONTH": "مسح رموز QR لهذا الشهر",
      "QR_SCANS_THIS_WEEK": "مسح رموز QR لهذا الأسبوع",
      "QR_SCANS_TODAY": "إجمالي مسح رموز QR اليوم",
      "USERS": "المستخدمين",
      "AGGREGATE_STATISTICS": "إحصائيات مجمعة",
      "TOTAL_APP_DOWNLOADS": "إجمالي تحميلات التطبيق",
      "TOTAL_NUMBER_OF_STORES": "إجمالي عدد المتاجر",
      "TOTAL_NUMBER_OF_USERS": "إجمالي عدد المستخدمين",
      "TOTAL_QR_CODE_SCANS_ON_APP": "إجمالي عمليات مسح QR على التطبيق",
      "STORES_SORTED_BY_MOST_QR_SCANS": "المتاجر مرتبة حسب أكثر عمليات مسح QR",
      "LOGO": "الشعار",
      "TOTAL_QR_CODE_SCANS": "إجمالي عمليات مسح QR",
      "GENERATE_QR": "توليد QR",
      "ADD_OFFERS": "إضافة عروض"





      },


    }
  }
};

  